


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const RecoredUserPaymentReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.RECORD_PAYMENT_CUSTOMER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.RECORD_PAYMENT_CUSTOMER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.RECORD_PAYMENT_CUSTOMER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
